export const categoryList = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-film-line",
    tagline: "院线质感",
    description: "剧情、悬疑、犯罪、爱情与公路片，一次看遍不同风格的长片佳作。",
    intro: "收录剧情、悬疑、犯罪、家庭、爱情等多样题材的长片资源，按更新与热度持续整理。",
  },
  {
    slug: "series",
    name: "剧集",
    icon: "ri-play-list-2-line",
    tagline: "连续叙事",
    description: "多集叙事的连续剧与迷你剧，适合一次追完的完整故事。",
    intro: "从年代群像到悬疑惊悚，剧集分类汇集了不同篇幅的连续剧与迷你剧资源。",
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    tagline: "真实记录",
    description: "自然、人文与社会观察，用镜头记录真实世界的样子。",
    intro: "自然生态、人文手艺、社会观察与科学纪实，纪录片分类带你看见真实的世界。",
  },
  {
    slug: "short",
    name: "短片",
    icon: "ri-movie-2-line",
    tagline: "短小精悍",
    description: "十几分钟讲完一个故事，通勤路上也能看完的短片集。",
    intro: "十几分钟到二十几分钟的短篇作品，节奏紧凑，适合碎片时间观看。",
  },
  {
    slug: "animation",
    name: "动画",
    icon: "ri-palette-line",
    tagline: "幻想世界",
    description: "手绘与三维动画长片，温柔又充满想象力的另一个世界。",
    intro: "手绘、剪纸与三维动画作品，用想象的画面讲述关于成长与陪伴的故事。",
  },
];

export const regionOptions = ["全部地区", "中国大陆", "中国香港", "中国台湾", "日本", "韩国", "欧美"];

export const eraOptions = ["全部年代", "2024", "2023", "2022", "2021", "2020 及以前"];

export const sortOptions = [
  { value: "latest", label: "最近更新" },
  { value: "hot", label: "热度最高" },
  { value: "rating", label: "评分最高" },
  { value: "year", label: "年份最新" },
];

export const genreOptions: Record<string, string[]> = {
  movie: ["全部题材", "剧情", "悬疑", "犯罪", "家庭", "爱情", "公路", "科幻"],
  series: ["全部题材", "悬疑", "家庭", "年代", "犯罪", "奇幻", "历史", "生活"],
  documentary: ["全部题材", "自然", "人文", "社会", "科学", "教育"],
  short: ["全部题材", "剧情", "悬疑", "温情", "爱情"],
  animation: ["全部题材", "奇幻", "治愈", "冒险", "童话"],
};